import { useMutation, useQuery } from 'react-query';
import { createApplicationCode, createDiagnosisCode, getApplicationCodes, getDiagnosisCodes } from '@/services/codes';

export const useGetDiagnosisCodes = ({
	page = 1,
	limit = 50,
	search = '',
	sort = '',
	enabled = true,
}: {
	page?: number;
	limit?: number;
	search?: string;
	sort?: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['diagnosisCodes', page, limit, search, sort],
		queryFn: () => getDiagnosisCodes(page, limit, search, sort),
		enabled,
		keepPreviousData: false,
	});
};

export const useGetApplicationCodes = ({
	page = 1,
	limit = 50,
	search = '',
	sort = '',
	enabled = true,
}: {
	page?: number;
	limit?: number;
	search?: string;
	sort?: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['applicationCodes', page, limit, search, sort],
		queryFn: () => getApplicationCodes(page, limit, search, sort),
		enabled,
		keepPreviousData: false,
	});
};

export const useCreateApplicationCode = (
	onSuccess?: (data: any) => void,
	onError?: (error: any) => void,
) => {
	return useMutation({
		mutationFn: (payload: { ta_name: string }) => createApplicationCode(payload),
		onSuccess: (data) => {
			onSuccess?.(data);
		},
		onError: (error) => {
			onError?.(error);
		},
	});
};

export const useCreateDiagnosisCode = (
	onSuccess?: (data: any) => void,
	onError?: (error: any) => void,
) => {
	return useMutation({
		mutationFn: (payload: { ta_name: string }) => createDiagnosisCode(payload),
		onSuccess: (data) => {
			onSuccess?.(data);
		},
		onError: (error) => {
			onError?.(error);
		},
	});
};

